import PropTypes from 'prop-types';
import DMOptOutFormContainer from '../dmOptOutForm/DMOptOutFormContainer';

const VARIANT_COMPONENTS = {
  DMOptOut: DMOptOutFormContainer,
};

export default function FormVariantRouter({ variant, ...props }) {
  const Component = VARIANT_COMPONENTS[variant];
  if (!Component) return null;
  return <Component variant={variant} {...props} />;
}

FormVariantRouter.propTypes = {
  variant: PropTypes.string.isRequired,
};
